(() => {
  const initialized = new WeakSet();
  function init(scope = document) {
    scope.querySelectorAll('[data-fendooy-toys]').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const filters = [...root.querySelectorAll('[data-filter]')];
      const cards = [...root.querySelectorAll('.product')];
      const count = root.querySelector('#results-count');
      const productDialog = root.querySelector('[data-product-dialog]');
      const guideDialog = root.querySelector('[data-guide-dialog]');
      filters.forEach(button => button.addEventListener('click', () => {
        filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.character !== button.dataset.filter; });
        count.textContent = cards.filter(card => !card.hidden).length + ' ' + root.dataset.resultsLabel;
      }));
      root.querySelectorAll('[data-product]').forEach(button => button.addEventListener('click', () => {
        const item = button.dataset;
        root.querySelector('[data-detail-brand]').textContent = item.brand;
        root.querySelector('[data-detail-title]').textContent = item.name;
        root.querySelector('[data-detail-series]').textContent = item.series;
        root.querySelector('[data-detail-type]').textContent = item.type;
        const image = root.querySelector('[data-detail-image]');
        image.src = item.original;
        image.alt = root.dataset.originalLabel + ': ' + item.brand + ' ' + item.name;
        productDialog.showModal();
        document.body.classList.add('dialog-open');
      }));
      root.querySelectorAll('[data-guide]').forEach(button => button.addEventListener('click', () => {
        guideDialog.showModal(); document.body.classList.add('dialog-open');
      }));
      root.querySelector('[data-guide-confirmed-link]').addEventListener('click', () => guideDialog.close());
      root.querySelectorAll('dialog').forEach(dialog => {
        dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => { if (!root.querySelector('dialog[open]')) document.body.classList.remove('dialog-open'); });
      });
      root.querySelectorAll('[data-character-link]').forEach(link => link.addEventListener('click', () => {
        filters.find(button => button.dataset.filter === link.dataset.characterLink)?.click();
      }));
    });
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
